
import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FlaskConical } from 'lucide-react';
import { useUser } from '@/context/UserContext';
import { WaitlistForm } from './testing/WaitlistForm';
import { SuccessMessage } from './testing/SuccessMessage';
import { InfoSection } from './testing/InfoSection';

const TestingTab: React.FC = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [signupCount, setSignupCount] = useState(2438); // This would ideally come from the backend
  const { user } = useUser();
  
  const handleSubmitSuccess = () => {
    setIsSubmitted(true);
    setSignupCount(prev => prev + 1);
  };
  
  const handleUpdateInfo = () => {
    setIsSubmitted(false);
  };
  
  return (
    <div className="space-y-6 animate-in fade-in-50">
      <Card className="border-hormony-coral/20 shadow-sm overflow-hidden">
        <div className="absolute top-0 right-0 w-32 h-32 -mr-10 -mt-10 bg-hormony-coral/10 rounded-full blur-2xl z-0"></div>
        <div className="absolute bottom-0 left-0 w-40 h-40 -ml-10 -mb-10 bg-purple-400/10 rounded-full blur-3xl z-0"></div>
        
        <CardHeader className="relative z-10">
          <div className="flex items-center space-x-2 mb-2">
            <FlaskConical className="h-6 w-6 text-hormony-coral" />
            <CardTitle className="text-xl font-display">Coming Soon – Personalized Hormone Insights!</CardTitle>
          </div>
        </CardHeader>
        
        <CardContent className="relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <InfoSection 
              signupCount={signupCount}
              isSubmitted={isSubmitted}
            />
            
            <div className="bg-white p-6 rounded-xl border shadow-sm">
              {!isSubmitted ? (
                <WaitlistForm 
                  initialEmail={user?.email || ''} 
                  onSubmitSuccess={handleSubmitSuccess} 
                />
              ) : (
                <SuccessMessage onUpdateInfo={handleUpdateInfo} />
              )}
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default TestingTab;
